import { render, staticRenderFns } from "./TrackTagsSelectModal.vue?vue&type=template&id=5b558095&"
import script from "./TrackTagsSelectModal.vue?vue&type=script&lang=ts&"
export * from "./TrackTagsSelectModal.vue?vue&type=script&lang=ts&"
import style0 from "./TrackTagsSelectModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports